import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { patchOnboardingStateOnServer, type OnboardingState } from '../../../utils/net/onboardingApi';

/** The first opening of the quests screen: the map's quests button stops glowing for good. */
export function useMarkQuestsOpened(isOpen: boolean) {
  const queryClient = useQueryClient();
  useEffect(() => {
    if (!isOpen) return;
    const state = queryClient.getQueryData<OnboardingState>(['onboarding-state']);
    if (state?.quests_opened) return;
    queryClient.setQueryData<OnboardingState>(['onboarding-state'], (old) => (old ? { ...old, quests_opened: true } : old));
    patchOnboardingStateOnServer({ quests_opened: true }).catch(() => { /* glows again next launch at worst */ });
  }, [isOpen, queryClient]);
}
